'use strict';

import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var Identifier = function () {
    function Identifier() {
        _classCallCheck(this, Identifier);
    }

    _createClass(Identifier, null, [{
        key: 'guid',
        value: function guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
    }]);

    return Identifier;
}();

export default Identifier;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/Identifier.js
// module id = 184
// module chunks = 0